import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import SEOHead from "@/components/SEOHead";
import injectionImg from "@/assets/injection-machine.webp";
import robotImg from "@/assets/robot.webp";
import auxiliariesImg from "@/assets/auxiliaries.webp";
import centralImg from "@/assets/central-systems.webp";

export default function Equipment() {
  const { t } = useLanguage();

  const categories = [
    { img: injectionImg, label: t("nav.injectionMachines"), desc: t("equipment.injectionDesc"), path: "/echipamente/masini-de-injectie" },
    { img: robotImg, label: t("nav.robots"), desc: t("equipment.robotsDesc"), path: "/echipamente/roboti" },
    { img: auxiliariesImg, label: t("nav.auxiliaries"), desc: t("equipment.auxiliariesDesc"), path: "/echipamente/auxiliare" },
    { img: centralImg, label: t("nav.centralSystems"), desc: t("equipment.centralDesc"), path: "/echipamente/sisteme-centralizate" },
  ];

  return (
    <div className="py-16 lg:py-24">
      <SEOHead
        title="Echipamente mase plastice"
        description="Gamă completă de mașini de injecție, roboți industriali, termoregulatoare, uscător plastic și sisteme centralizate WITTMANN pentru injecție plastic și prelucrare mase plastice."
        path="/echipamente"
        keywords="masini de injectie, roboti industriali, termoregulatoare, uscator plastic, echipamente mase plastice, injectie plastic, robot plastice"
      />
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-14"
        >
          <h1 className="text-3xl lg:text-5xl font-bold text-foreground mb-3">{t("equipment.title")}</h1>
          <p className="text-lg text-muted-foreground">{t("equipment.subtitle")}</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {categories.map((cat, i) => (
            <motion.div
              key={cat.path}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              <Link
                to={cat.path}
                className="group block bg-card border border-border rounded-xl overflow-hidden hover:shadow-lg transition-shadow"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={cat.img}
                    alt={cat.label}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-6">
                  <h2 className="text-xl font-bold text-foreground mb-2">{cat.label}</h2>
                  <p className="text-sm text-muted-foreground mb-4">{cat.desc}</p>
                  <span className="inline-flex items-center gap-1 text-sm font-semibold text-primary">
                    {t("equipment.explore")}
                    <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
